<svg name="axis" class="chart axis" shape-rendering="optimizeSpeed"></svg>
<div class="scroll-gradient">
  <div name="detailsScroll" class="details-scroll">
    <svg name="details" class="chart details" shape-rendering="optimizeSpeed"></svg>
  </div>
</div>
